'use client';

import { useLocale } from 'next-intl';

import { getTextDirection } from '@/lib/utils/locale';

export function usePageDirection() {
  const locale = useLocale();
  return getTextDirection(locale);
}
